import axios from 'axios';
import moment from 'moment-timezone';
import {
  getAuth,
} from 'firebase/auth';
import {
  getDatabase,
  ref,
  onValue,
  update,
  get,
  child,
} from 'firebase/database';
import {
  getFirestore,
  doc,
  getDocFromServer,
} from 'firebase/firestore';
import { eventChannel } from 'redux-saga';
import {
  all,
  takeLatest,
  put,
  call,
  fork,
  take,
  takeEvery,
  select,
  // select,
} from 'redux-saga/effects';
import actions from './actions';
import appActions from '../app/actions';
import authActions from '../auth/actions';

// const getWaitRoomQueue = (state) => state.Tv.waitRoomQueue;
// const getTest = (state) => state.Tv;
const getMainUserFromStore = (state) => state.Auth.mainUser;

function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

function createTvListener(id) {
  const db = getDatabase();
  const listener = eventChannel((emit) => {
    const tvRef = ref(db, `tv/${id.toUpperCase()}`);
    const unsubscribe = onValue(tvRef, (req) => (
      emit(req.val() || {})
    ));
    return () => unsubscribe();
  });
  return listener;
}

export function* getWaitRoomQueuePatients() {
  let currentListener = null;
  yield takeLatest([
    actions.CREATE_TV_LISTENER,
  ], function* (action) {
    if (currentListener) {
      currentListener.close();
      currentListener = null;
    }
    currentListener = yield call(createTvListener, action.payload);
    yield takeEvery(currentListener, function* (tv) {
      yield put({
        type: actions.UPDATE_PATIENTS_LIST,
        payload: {
          id: action.payload,
          ...tv,
        },
      });
    });
    const actionTriggered = yield take([
      appActions.CANCEL_LISTENERS,
    ]);
    currentListener.close();
    currentListener = null;
    if (actionTriggered?.type === 'CANCEL_LISTENERS') {
      yield put({
        type: appActions.CANCEL_LISTENERS_SUCCESS,
      });
    }
  });
}

function getTvProfessionalPermissionsFromDB(mainUser) {
  const fs = getFirestore();
  let uid;
  if (mainUser) {
    uid = mainUser;
  } else {
    const auth = getAuth();
    const { currentUser } = auth;
    ({ uid } = currentUser);
  }
  const userRef = doc(
    fs,
    'professionals',
    uid,
    'tv',
    'users',
  );
  return getDocFromServer(userRef);
}

export function* getTvProfessionalPermissions() {
  yield takeEvery([
    authActions.LOGIN_SUCCESS,
  ], function* () {
    try {
      const mainUser = yield select(getMainUserFromStore);
      const tvPermissions = yield call(getTvProfessionalPermissionsFromDB, mainUser);
      if (tvPermissions.data()) {
        yield put({
          type: actions.GET_TV_PERMISSION_SUCCESS,
          payload: {
            permissions: {
              ...tvPermissions.data(),
            },
          },
        });
      } else {
        throw new Error('No Tv data');
      }
    } catch (error) {
      console.warn(error.message);
    }
  });
}

function getApiData() {
  return axios.get('https://api.weatherapi.com/v1/current.json?key=ddbb17be97414e1e898133555240406&q=maringa');
}

function* requestWeather() {
  yield takeLatest(actions.REQUEST_WEATHER_FOR_TV, function* () {
    try {
      yield put({ type: actions.REQUEST_WEATHER_FOR_TV_WAITING });
      const watherResponse = yield call(getApiData);
      if (watherResponse?.data?.current?.temp_c) {
        yield put({
          type: actions.REQUEST_WEATHER_FOR_TV_SUCCESS,
          payload: watherResponse?.data?.current?.temp_c,
        });
      }
    } catch (error) {
      console.warn(error.message);
      yield put({
        type: actions.REQUEST_WEATHER_FOR_TV_ERROR,
      });
    }
  });
}

function callPatientTvOnDB(payload, oldTvValue) {
  const db = getDatabase();
  const dbRef = ref(db);
  const {
    tvId,
    patient,
    tvProfessional,
    tvClinic,
    tvRoom,
  } = payload;
  const patientCall = {
    id: Date.now(),
    room: tvRoom,
    name: patient,
    clinic: tvClinic,
    professional: tvProfessional,
  };
  const newArray = {
    ...oldTvValue,
    waitRoomQueue: oldTvValue?.waitRoomQueue ? [patientCall, ...oldTvValue.waitRoomQueue] : [patientCall],
    location: payload?.location || '',
  };
  if (newArray?.waitRoomQueue.length > 10) {
    newArray.waitRoomQueue.pop();
  }
  const updates = {};
  updates[`tv/${tvId}`] = newArray;
  return update(dbRef, updates);
}

function getTvValueOnDB(payload) {
  const db = getDatabase();
  const dbRef = ref(db);
  return get(child(dbRef, `tv/${payload?.tvId?.toUpperCase()}`));
}

function* callPatientTv() {
  yield takeLatest(actions.CALL_PATIENT_TV, function* (action) {
    const result = yield call(getTvValueOnDB, action.payload);
    const oldTvValue = result.val();
    try {
      yield call(callPatientTvOnDB, action.payload, oldTvValue);
      yield put({
        type: actions.SAVE_TV_INFO_ON_CACHE,
        payload: action.payload,
      });
      yield sleep(1000);
      yield put({
        type: actions.CALL_PATIENT_TV_SUCCESS,
      });
    } catch (error) {
      console.warn(error.message);
      yield put({
        type: actions.CALL_PATIENT_TV_ERROR,
      });
    }
  });
}

function* setTvIdCache(value) {
  yield call(() => localStorage.setItem('tvId', value.toUpperCase()));
}

function* checkIfIdExists(id) {
  const db = getDatabase();
  const dbRef = ref(db);
  if (!id) {
    return false;
  }
  const snapshot = yield call(() => get(child(dbRef, `tv/${id.toUpperCase()}`)));
  return snapshot.exists();
}

function createTvIdOnDB(id) {
  const db = getDatabase();
  const dbRef = ref(db);
  const updates = {};
  const createTvObject = {
    waitRoomQueue: {},
    timestamp: moment().tz('America/Sao_Paulo').format(),
  };
  updates[`tv/${id}`] = createTvObject;
  return update(dbRef, updates);
}

function* startTv() {
  yield takeLatest(actions.START_TV, function* () {
    try {
      let tvID = null;
      tvID = yield call(() => localStorage.getItem('tvId'));
      const valid = yield call(checkIfIdExists, tvID);
      if (!valid) {
        tvID = '';
        yield call(setTvIdCache, '');
      }
      if (!tvID) {
        let isUniqueId = false;
        while (!isUniqueId) {
          let result = '';
          const characters = 'ABCDEFGHIJKLMNOPQRSTUVXWYZ0123456789';
          const charactersLength = characters.length;
          let counter = 0;
          while (counter < 4) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
          }
          isUniqueId = yield call(checkIfIdExists, result);
          if (isUniqueId) {
            yield sleep(1000);
          } else {
            isUniqueId = true;
            tvID = result;
          }
        }
        yield call(createTvIdOnDB, tvID);
        yield call(setTvIdCache, tvID);
      }
      yield put({
        type: actions.CREATE_TV_LISTENER,
        payload: tvID,
      });
      yield put({
        type: actions.REQUEST_WEATHER_FOR_TV,
      });
    } catch (error) {
      console.warn(error.message);
      yield put({
        type: actions.START_TV_ERROR,
      });
    }
  });
}

function* setCodeForTvIdCache(value) {
  yield call(() => localStorage.setItem('tvIdProfessional', value.toUpperCase()));
}

function* validateCodeProvidedByProfessional() {
  yield takeLatest(actions.VALIDATE_CODE_PROVIDED_BY_PROFESSIONAL, function* (action) {
    try {
      yield put({
        type: actions.VALIDATE_CODE_PROVIDED_BY_PROFESSIONAL_WAITING,
      });
      yield sleep(1000);
      const {
        isStartingTv,
        code,
      } = action.payload;
      const valid = yield call(checkIfIdExists, code);
      if (valid) {
        if (isStartingTv) {
          yield call(setTvIdCache, code);
        } else {
          yield call(setCodeForTvIdCache, code);
        }

        yield put({
          type: actions.VALIDATE_CODE_PROVIDED_BY_PROFESSIONAL_VALID,
          payload: action.payload.code,
        });
      } else {
        throw new Error('Could not find TV with this code');
      }
    } catch (error) {
      console.warn(error.message);
      yield put({
        type: actions.VALIDATE_CODE_PROVIDED_BY_PROFESSIONAL_ERROR,
      });
    }
  });
}

function* getProfessionaTvCode() {
  yield takeLatest(actions.GET_STORED_CODE_FOR_TV_CACHED_ON_PROFESSIONAL_PC, function* () {
    try {
      const tvID = yield call(() => localStorage.getItem('tvIdProfessional'));
      if (tvID) {
        const valid = yield call(checkIfIdExists, tvID);
        if (valid) {
          yield put({
            type: actions.VALIDATE_CODE_PROVIDED_BY_PROFESSIONAL_VALID,
            payload: tvID,
          });
        } else {
          yield call(setTvIdCache, '');
          throw new Error('Could not find TV with this code');
        }
      } else {
        yield put({
          type: actions.VALIDATE_CODE_PROVIDED_BY_PROFESSIONAL_VALID,
          payload: null,
        });
      }
    } catch (error) {
      console.warn(error.message);
      yield put({
        type: actions.VALIDATE_CODE_PROVIDED_BY_PROFESSIONAL_ERROR,
      });
    }
  });
}

function* resetTvCodeOnCache() {
  yield takeLatest(actions.RESET_TV_CODE_ON_CACHE, function* () {
    try {
      yield call(setCodeForTvIdCache, '');
      yield put({
        type: actions.RESET_TV_CODE_ON_CACHE_FINISHED,
      });
      yield put({
        type: actions.GET_CACHED_VALUES_FOR_TV,
      });
    } catch (error) {
      console.warn(error.message);
    }
  });
}

function* getCachedValuesForTv() {
  yield takeLatest(actions.GET_CACHED_VALUES_FOR_TV, function* () {
    try {
      const clinic = yield call(() => localStorage.getItem('tvClinic'));
      const professional = yield call(() => localStorage.getItem('tvProfessional'));
      const room = yield call(() => localStorage.getItem('tvRoom'));
      yield put({
        type: actions.GET_CACHED_VALUES_FOR_TV_FINISHED,
        payload: {
          clinic: clinic || '',
          professional: professional || '',
          room: room || '',
        },
      });
    } catch (error) {
      console.warn(error.message);
    }
  });
}

function* saveTvInfoOnCache() {
  yield takeLatest(actions.SAVE_TV_INFO_ON_CACHE, function* (action) {
    try {
      const {
        tvProfessional,
        tvClinic,
        tvRoom,
        shouldReload,
      } = action.payload;
      yield call(() => localStorage.setItem('tvClinic', tvClinic));
      yield call(() => localStorage.setItem('tvProfessional', tvProfessional));
      yield call(() => localStorage.setItem('tvRoom', tvRoom));
      yield put({
        type: actions.SAVE_TV_INFO_ON_CACHE_SUCCESS,
      });
      if (shouldReload) {
        yield put({
          type: actions.GET_CACHED_VALUES_FOR_TV,
        });
      }
    } catch (error) {
      console.warn(error.message);
      yield put({
        type: actions.SAVE_TV_INFO_ON_CACHE_ERROR,
      });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(requestWeather),
    fork(getWaitRoomQueuePatients),
    fork(callPatientTv),
    fork(startTv),
    fork(validateCodeProvidedByProfessional),
    fork(getProfessionaTvCode),
    fork(resetTvCodeOnCache),
    fork(getCachedValuesForTv),
    fork(saveTvInfoOnCache),
    fork(getTvProfessionalPermissions),
  ]);
}
